import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5a580c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/pages/Documentacao/Views/stylesManual.scss?vue&type=style&index=0&id=b5a580c0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a580c0",
  null
  
)

export default component.exports